module.exports = __webpack_public_path__ + "static/illus_funciona_2_3x_resized-deaf43f26e4b0c7569bd9f008ec202bc.webp";